module.exports = __webpack_public_path__ + "img/49.cd0baaba.jpg";